import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';

/* Modified มาจาก
SelectProvince.js 
*/

export default function Asynchronous(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const { rhf, control, name , employeeId} = props;

  //ทำงานเมื่อคลิกไปที่ช่อง
  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      console.log('---call API organizations ---');

      var config = {
        method: 'get',
        url: `/api/cis/organizations`,
      };

      axios(config)
        .then(function (response) {
          console.log('---organizations response---', response.data);
          // response.data = response.data;
          if (active) {
            if (response.data.length === 0) {
              setOptions([]);
            } else {           
              setOptions(response.data.map(item => item.organization));
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <rhf.Controller
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          freeSolo
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          loading={loading}
          options={options}
          value={value || ''}
          onInputChange={(_, newValue) => onChange(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              label="สังกัด"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
            />
          )}
        />
      )}
      name={name}
      control={control}
    />
  );
}
